import { InitialAssessmentPageRoute } from "@pages/AssessmentReportV2Details/types";

export const routeLabelMapping: { [key in InitialAssessmentPageRoute]: string } = {
  "client-details": "Details",
  "upload-files": "Upload Files",
  "report-part-1": "Report Part 1",
  prioritize: "Prioritize",
  "short-term-goals": "Short Term Goals",
  "report-part-2": "Report Part 2",
  "review-and-sign": "Review",
};

const baseRoutes: InitialAssessmentPageRoute[] = ["client-details", "upload-files", "report-part-1", "prioritize"];

const finalRoutes: InitialAssessmentPageRoute[] = ["report-part-2", "review-and-sign"];

export const getOrderedAssessmentReportSubRoutes = () => {
  const goalRoutes: InitialAssessmentPageRoute[] = ["short-term-goals"];

  const orderedRoutes = [...baseRoutes, ...goalRoutes, ...finalRoutes] as InitialAssessmentPageRoute[];

  return {
    orderedRoutes,
    getNextRoute: (route: InitialAssessmentPageRoute) => {
      const currentIndex = orderedRoutes.indexOf(route);
      if (route === "review-and-sign") return "review-and-sign";
      return currentIndex >= 0 && currentIndex < orderedRoutes.length - 1 ? orderedRoutes[currentIndex + 1] : null;
    },
    getPastRoute: (route: InitialAssessmentPageRoute) => {
      const currentIndex = orderedRoutes.indexOf(route);
      return currentIndex > 0 ? orderedRoutes[currentIndex - 1] : "client-details";
    },
    statusFromCurrentRoute: (currentRoute: InitialAssessmentPageRoute, navStepRoute: InitialAssessmentPageRoute) => {
      if (currentRoute === navStepRoute) return "current";
      return orderedRoutes.indexOf(currentRoute) > orderedRoutes.indexOf(navStepRoute) ? "complete" : "upcoming";
    },
  };
};
